import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import VideoFrameAnalyzer from './components/VideoFrameAnalyzer';
import ClientPage from './components/ClientPage';
import PatientJoin from './components/PatientJoin';
import ClinicianConsole from './components/ClinicianConsole';
import OnCallView from './components/OnCallView';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<ClinicianConsole />} />
          <Route path="/console" element={<ClinicianConsole />} />
          <Route path="/client" element={<ClientPage />} />
          <Route path="/join" element={<PatientJoin />} />
          {/* On-call doctor arriving from the escalation SMS, on a phone. */}
          <Route path="/oncall" element={<OnCallView />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
